
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ottawa",
      function () {
        return require("private-next-pages/ottawa.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ottawa"])
      });
    }
  